import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ParseService } from '../parse/parse.service';
import { QueryInterface } from '../parse/query-interface';

export class Project {
    id: string;
    role: string;
    projectInfo: object;
    otherInfo: object;
    startDate: Date;
    resourcesType: string;
    comments: [];
    client: string;
    endDate: Date;
    status: string;
    username: string;
    schedulerStatus: string;
    resourceDetails = [];
    activities = [];
    projectType: any;
}

@Injectable({
    providedIn: 'root'
})

export class GetterSetter {

    project = new Project();
    userId: any;
    private subject = new Subject<any>();

    constructor(
        private parseService: ParseService,
        private queryInterface: QueryInterface
    ) { }

    getProject(results) {
        this.project.id = results.id
        this.project.projectInfo = results.get('projectInfo');
        this.project.schedulerStatus = results.get('schedulerStatus');
        this.project.comments = results.get('comments');
        var client = results.get('client');
        this.project.resourceDetails = results.get('resourceDetails');
        this.project.client = client.id;
        this.project.activities = results.get('activities');
        this.project.projectType = results.get('projectType');
        return this.project;
    }

    updateProject(user_id, projectValue): Promise<any> {
        return new Promise((resolve, reject) => {
            this.queryInterface.executeQuery(this.parseService, 'Project', [{ condition: 'equalTo', field: 'objectId', value: user_id }]).then(result => {
                var results = result[0];
                let client = results.get('client');
                client.id = projectValue.projectInfo.clientName;
                results.set('client', client);
                results.set('activities', projectValue.activities);
                results.set('projectInfo', projectValue.projectInfo);
                results.set('otherInfo', projectValue.otherInfo);
                results.set('comments', projectValue.comments);
                results.set('resourceDetails', projectValue.resourceDetails);

                if (projectValue.projectInfo.currentStatus == 'Archived') {
                    results.set('isActive', false);
                } else {
                    results.set('isActive', true);
                }
                results.save().then(rest => {
                    resolve(rest);
                }, reject);
            });
        });
    }

    addGMTOffset(somedate) {
        let date = somedate._d;
        if (!date) {
            date = somedate;
        }
        var datewithoffset = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
        );
        return datewithoffset;
    }

    updateProjectMember(user_id, projectValue): any {
        this.queryInterface.executeQuery(this.parseService, 'ProjectMembers', [{ condition: 'equalTo', field: 'objectId', value: user_id }]).then(result => {
            var results = result[0];
            // results.set('startDate', projectValue.startdate1);
            // results.set('endDate', projectValue.enddate1);
            results.set('Hours', Number(projectValue.hours ? projectValue.hours : 0));
            results.set('Month', Number(projectValue.months ? projectValue.months : 0));
            results.set('status', projectValue.popupStatus);
            results.save({
                success: function (_profile) {
                    this.toastr.success('Saved Successfully');
                },
                error: function (error) {
                }
            });
        });
    }

    getProjectMember(results) {
        this.project.username = results.get('username');
        this.project.startDate = results.get('startDate');
        this.project.endDate = results.get('endDate');
        this.project.status = results.get('status');
        this.project.role = results.get('role');
        return this.project;
    }

    sendMessage(message: string) {
        this.subject.next({ text: message });
    }

    onMessage(): Observable<any> {
        return this.subject.asObservable();
    }

}